module.exports = __webpack_public_path__ + "static/adjustable-base-2-massage-a5234cc48ff9d462b7cbf1714875124c.webp";